export const FETCH_PRIVILEGES = "FETCH_PRIVILEGES";
export const GIVE_PRIVILEGES = "GIVE_PRIVILEGES";
export const GET_CLIP_MOMENTS = "GET_CLIP_MOMENTS";
export const FETCH_SUPPORT_USERS = "FETCH_SUPPORT_USERS";
export const GET_SUPPORT_USERS = "GET_SUPPORT_USERS";
export const FETCH_PRIVILEGES_WITH_REGIONS = "FETCH_PRIVILEGES_WITH_REGIONS";
export const GET_PRIVILEGES_WITH_REGIONS = "GET_PRIVILEGES_WITH_REGIONS";